import { isEmpty } from "@s-libs/micro-dash";

import { SCHOOL_INITIAL_STATE } from "../AdminConsoleSchoolRecordPage.utils";

export const INITIAL_FORM_STATE = SCHOOL_INITIAL_STATE.schoolGeneralInformation;

export const FORM_ERROR_MESSAGES = {
  schoolName: "Enter a school name",
  streetAddress: "Enter a street address",
  city: "Enter a city",
  state: "Select a state",
  zip: "Enter a zip code",
  emailDomains: "Enter a valid email domain",
  website: "The url does not comply with the format",
};

export const isFormValid = (values) => {
  const { schoolName, streetAddress, city, state, zip, emailDomains, website } =
    values;
  // if all editable fields are disabled, school update should't be allowed.
  if (
    [schoolName, streetAddress, city, state, zip, emailDomains, website].every(
      (value) => value.disabled,
    )
  )
    return false;
  // check if any email domain has error.
  const hasEmailDomainsErrors = emailDomains.value.some(
    (domain) => !!domain.error,
  );

  const requiredFieldsNotEmpty = [
    !isEmpty(schoolName.value),
    !isEmpty(streetAddress.value),
    !isEmpty(city.value),
    !isEmpty(state.value),
    !isEmpty(zip.value),
  ].every((field) => !!field);

  // fields must be error's clean to allow school update.
  return [
    requiredFieldsNotEmpty,
    !schoolName?.error,
    !streetAddress?.error,
    !city?.error,
    !state?.error,
    !zip?.error,
    !hasEmailDomainsErrors,
    !website?.error,
  ].every((result) => !!result);
};

export const mapFormValues = (values) => {
  const formValues = {};
  Object.entries(values).forEach(([name, field]) => {
    const { value, editable } = field;
    formValues[name] = {
      name,
      value,
      disabled: !editable,
      touched: false,
      error: null,
    };
  });
  formValues.isValid = isFormValid(formValues);
  return formValues;
};

export const schoolStatusValue = (isSchoolConfirmed) => {
  switch (isSchoolConfirmed) {
    case true:
      return "Validated";
    case false:
      return "Unapproved";
    default:
      return "Unconfirmed";
  }
};

export const readOnlyFieldMessage = (isDisabled) =>
  isDisabled ? "Read-only data" : null;

export const isEmailValid = (email) =>
  /\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email);

const unicodeLetters = "\u00a1-\uffff"; // Unicode letters range (must not be a raw string).

// IP patterns
const ipv4 =
  "(?:0|25[0-5]|2[0-4]d|1d?d?|[1-9]d?)" +
  "(?:.(?:0|25[0-5]|2[0-4]d|1d?d?|[1-9]d?)){3}";

const ipv6 = "[[0-9a-f:.]+]";

// Host patterns
const hostname =
  "[a-z" +
  unicodeLetters +
  "0-9](?:[a-z" +
  unicodeLetters +
  "0-9-]{0,61}[a-z" +
  unicodeLetters +
  "0-9])?";

// Max length for domain name labels is 63 characters per RFC 1034 sec. 3.1
const domain = "(?:.(?!-)[a-z" + unicodeLetters + "0-9-]{1,63}(?<!-))*";
const tld =
  "." + // dot
  "(?!-)" + // can't start with a dash
  "(?:[a-z" +
  unicodeLetters +
  "-]{2,63}" + // domain label
  "|xn--[a-z0-9]{1,59})" + // or punycode label
  "(?<!-)" + // can't end with a dash
  ".?"; // may have a trailing dot

const host = "(" + hostname + domain + tld + "|localhost)";

// Validation code from https://docs.djangoproject.com/en/4.0/_modules/django/core/validators/#URLValidator
export const isWebsiteValid = (website) => {
  const regexList = [
    "^(?:[a-z0-9.+-]*)://", // scheme is validated separately
    "(?:[^s:@/]+(?::[^s:@/]*)?@)?", // user:pass authentication
    "(?:" + ipv4 + "|" + ipv6 + "|" + host + ")",
    "(?::d{1,5})?", // port
    "(?:[/?#][^s]*)?", // resource path
  ];

  const regex = new RegExp(regexList.join(""), "i");

  return regex.test(website);
};
